/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_View_ResultInputs */

const en_landing_studio_view_result = /** @type {(inputs: Landing_Studio_View_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const zh_landing_studio_view_result = /** @type {(inputs: Landing_Studio_View_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结果`)
};

/**
* | output |
* | --- |
* | "Result" |
*
* @param {Landing_Studio_View_ResultInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_view_result = /** @type {((inputs?: Landing_Studio_View_ResultInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_View_ResultInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_view_result(inputs)
	return zh_landing_studio_view_result(inputs)
});
export { landing_studio_view_result as "landing.studio.view_result" }